// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__QFDma","confirmShareButton":"styles_confirmShareButton__R9UDZ"};